import { removeTrailingZeroes } from "documents/utils";
import i18next from "i18next";

export const convertGramsToKilo = (value: number | undefined) =>
  typeof value === "number" && !isNaN(value) ? removeTrailingZeroes((value / 1000).toFixed(3)) : 0;

export const localizeWeight = (value: number) =>
  `${convertGramsToKilo(value)}  ${i18next.t("weight.kilogram")}`;
